module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzEiIGhlaWdodD0iMzYiIHZpZXdCb3g9IjAgMCAzMSAzNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxwYXRoIGQ9Ik03LjU1NTA1IDIyLjIwNDVDNy41NTUwNSAyNi43Mjk2IDEwLjMwNTUgMjkuNjY0NiAxNS4xMzYgMjkuNjY0NkMxOS45NjIzIDI5LjY2NDYgMjIuNjkxMSAyNi43Mjk2IDIyLjY5MTEgMjIuMjA0NVYwLjUzNDY2OEgzMC4yNDYxVjIyLjkxNUMzMC4yNDYxIDMwLjcxNzcgMjQuMzY5IDM1Ljk5OTggMTUuMTM2IDM1Ljk5OThDNS45MDMwNiAzNS45OTk4IDAgMzAuNzE3NyAwIDIyLjkxNVYwLjUzNDY2OEg3LjU1NTA1VjIyLjIwNDVaIiBmaWxsPSJ3aGl0ZSIvPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/navbar/logo-nano.svg
// module id = 4kEk
// module chunks = 1